'use strict';

const helper = require('./helpers/helper');

/**
 * Get Pay Later message element
 * @returns {null|HTMLElement} - html element or null if not found
 */
const getMessageEl = () => document.querySelector('[data-pp-message]');

const ppMessageEl = getMessageEl();

/**
 * Update Pay Later message amount for Product page (simple product, bundles, sets)
 */
function updatePayLaterMessageAmountForProduct() {
    const isProductBundle = document.querySelectorAll('.bundle-items').length;

    if (isProductBundle && ppMessageEl) {
        const priceEl = document.querySelector('.price .sales .value');
        const quantityEl = document.querySelector('.quantity-select');

        quantityEl.addEventListener('change', () => {
            const price = parseFloat(priceEl.getAttribute('content'));
            const quantity = parseFloat(quantityEl.value);

            ppMessageEl.dataset.ppAmount = price * quantity;
        });
    }

    $('body').on('product:afterAttributeSelect', (_, { data: { product }, container }) => {
        const newPrice = helper.getProductPrice(product);
        const creditMessage = container[0].querySelector('[data-pp-message]');

        creditMessage && creditMessage.setAttribute('data-pp-amount', newPrice);
    });
}

/**
 * Update Pay Later message amount for Cart, Category pages
 * @param {Object} _ - Event data
 * @param {Object} data - Data passed by trigger
 * @returns {void}
 */
const updatePayLaterMessageAmount = (_, data) => {
    if (data?.error || !ppMessageEl) {
        return;
    }

    if (ppMessageEl.dataset.ppPlacement === 'product') {
        return;
    }

    let total;
    let checkElementAgain = false;

    if ('cart' in data) {
        total = data.cart.totals.grandTotal;
    } else if ('basket' in data) {
        total = data.basket.totals.grandTotal;
        checkElementAgain = data.basket.items.length === 0;
    } else {
        total = data.totals.grandTotal;
    }

    if (checkElementAgain && !getMessageEl()) {
        return;
    }

    total = parseFloat(total.replace(/[^0-9.]/g, ''));

    ppMessageEl.dataset.ppAmount = total;
};

updatePayLaterMessageAmountForProduct();

$('body')
    .on('cart:update', updatePayLaterMessageAmount)
    .on('count:update', updatePayLaterMessageAmount);
